import {
  projectSymbol,
  documentSymbol,
  nodeSymbol,
  nodeChildrenSymbol,
  designerSymbol,
  skeletonSymbol,
  editorSymbol,
  settingFieldSymbol,
  settingTopEntrySymbol,
  designerCabinSymbol,
  propSymbol,
  simulatorHostSymbol,
  skeletonItemSymbol,
} from '@alilc/lowcode-shell';

export default {
  projectSymbol,
  documentSymbol,
  nodeSymbol,
  nodeChildrenSymbol,
  skeletonSymbol,
  editorSymbol,
  designerSymbol,
  settingPropEntrySymbol: settingFieldSymbol,
  settingTopEntrySymbol,
  designerCabinSymbol,
  propSymbol,
  simulatorHostSymbol,
  skeletonItemSymbol,
};
